var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f8f8f8;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9683",
    "data-name": "Group 9683",
    transform: "translate(-108)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9661",
    "data-name": "Group 9661",
    transform: "translate(147.375 39.375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9659",
    "data-name": "Group 9659",
    transform: "translate(9.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6999",
    "data-name": "Path 6999",
    className: "cls-2",
    d: "M145.25,47.25c-6.375,0-11.25-6-11.25-14.062C134,27.563,135.313,21,145.25,21s11.25,6.563,11.25,12.188C156.5,41.25,151.625,47.25,145.25,47.25Zm0-22.5c-5.625,0-7.5,2.063-7.5,8.438,0,5.063,2.625,10.313,7.5,10.313s7.5-5.25,7.5-10.312C152.75,26.813,150.875,24.75,145.25,24.75Z",
    transform: "translate(-134 -21)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9660",
    "data-name": "Group 9660",
    transform: "translate(0 20.812)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7000",
    "data-name": "Path 7000",
    className: "cls-2",
    d: "M164.625,52.538h-30c-3,0-5.625-3.375-5.625-7.5v-3.75a1.969,1.969,0,0,1,.938-1.687l13.125-7.5,1.875,3.188L132.75,42.225v2.813c0,2.25,1.313,3.75,1.875,3.75h30c.563,0,1.875-1.5,1.875-3.75V42.413l-12.187-6.937,1.875-3.187,13.125,7.5a1.969,1.969,0,0,1,.938,1.688v3.75C170.25,49.163,167.625,52.538,164.625,52.538Z",
    transform: "translate(-129 -32.1)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9662",
    "data-name": "Group 9662",
    transform: "translate(160.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7001",
    "data-name": "Path 7001",
    className: "cls-2",
    d: "M149.125,15h-11.25A1.771,1.771,0,0,1,136,13.125V1.875A1.771,1.771,0,0,1,137.875,0h11.25A1.771,1.771,0,0,1,151,1.875v11.25A1.771,1.771,0,0,1,149.125,15Zm-9.375-3.75h7.5V3.75h-7.5Z",
    transform: "translate(-136)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9663",
    "data-name": "Group 9663",
    transform: "translate(158.531 105.094)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7002",
    "data-name": "Path 7002",
    className: "cls-2",
    d: "M151.919,70.956h-15a1.969,1.969,0,0,1-1.687-.937,1.7,1.7,0,0,1,0-1.875l7.5-11.25a1.927,1.927,0,0,1,3.187,0l7.5,11.25a1.7,1.7,0,0,1,0,1.875A1.485,1.485,0,0,1,151.919,70.956Zm-11.438-3.75h8.063l-3.938-6Z",
    transform: "translate(-134.95 -56.05)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9664",
    "data-name": "Group 9664",
    transform: "translate(108 52.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7003",
    "data-name": "Path 7003",
    className: "cls-2",
    d: "M115.5,43a7.5,7.5,0,1,1,7.5-7.5A7.522,7.522,0,0,1,115.5,43Zm0-11.25a3.75,3.75,0,1,0,3.75,3.75A3.761,3.761,0,0,0,115.5,31.75Z",
    transform: "translate(-108 -28)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9665",
    "data-name": "Group 9665",
    transform: "translate(213 52.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7004",
    "data-name": "Path 7004",
    className: "cls-2",
    d: "M177.125,43a1.7,1.7,0,0,1-1.312-.562l-11.25-11.25a1.856,1.856,0,0,1,2.625-2.625l11.25,11.25a1.813,1.813,0,0,1,0,2.625A1.7,1.7,0,0,1,177.125,43Z",
    transform: "translate(-164 -28)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9666",
    "data-name": "Group 9666",
    transform: "translate(213 52.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7005",
    "data-name": "Path 7005",
    className: "cls-2",
    d: "M165.875,43a1.7,1.7,0,0,1-1.312-.562,1.813,1.813,0,0,1,0-2.625l11.25-11.25a1.856,1.856,0,0,1,2.625,2.625l-11.25,11.25A1.7,1.7,0,0,1,165.875,43Z",
    transform: "translate(-164 -28)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9667",
    "data-name": "Group 9667",
    transform: "translate(115.5 7.313)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7006",
    "data-name": "Path 7006",
    className: "cls-2",
    d: "M115.563,43.838,112,42.9a54.4,54.4,0,0,1,39-39l.938,3.563A50.383,50.383,0,0,0,115.563,43.838Z",
    transform: "translate(-112 -3.9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9668",
    "data-name": "Group 9668",
    transform: "translate(115.313 72.937)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7007",
    "data-name": "Path 7007",
    className: "cls-2",
    d: "M151.087,78.65A54.4,54.4,0,0,1,111.9,39.838l3.563-.937a50.447,50.447,0,0,0,36.375,36.187Z",
    transform: "translate(-111.9 -38.9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9669",
    "data-name": "Group 9669",
    transform: "translate(180.563 72.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7008",
    "data-name": "Path 7008",
    className: "cls-2",
    d: "M147.638,78.738l-.937-3.563A50.691,50.691,0,0,0,183.075,38.8l3.562.938A53.791,53.791,0,0,1,147.638,78.738Z",
    transform: "translate(-146.7 -38.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9670",
    "data-name": "Group 9670",
    transform: "translate(180.75 7.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7009",
    "data-name": "Path 7009",
    className: "cls-2",
    d: "M182.987,43.75A50.513,50.513,0,0,0,146.8,7.563L147.737,4A53.917,53.917,0,0,1,186.55,42.813Z",
    transform: "translate(-146.8 -4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9671",
    "data-name": "Group 9671",
    transform: "translate(138 58.125)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2737",
    "data-name": "Rectangle 2737",
    className: "cls-2",
    width: 3.75,
    height: 3.75
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9672",
    "data-name": "Group 9672",
    transform: "translate(130.5 58.125)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2738",
    "data-name": "Rectangle 2738",
    className: "cls-2",
    width: 3.75,
    height: 3.75
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9673",
    "data-name": "Group 9673",
    transform: "translate(201.75 58.125)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2739",
    "data-name": "Rectangle 2739",
    className: "cls-2",
    width: 3.75,
    height: 3.75
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9674",
    "data-name": "Group 9674",
    transform: "translate(194.25 58.125)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2740",
    "data-name": "Rectangle 2740",
    className: "cls-2",
    width: 3.75,
    height: 3.75
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9675",
    "data-name": "Group 9675",
    transform: "translate(166.125 86.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2741",
    "data-name": "Rectangle 2741",
    className: "cls-2",
    width: 3.75,
    height: 3.75
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9676",
    "data-name": "Group 9676",
    transform: "translate(166.125 93.75)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2742",
    "data-name": "Rectangle 2742",
    className: "cls-2",
    width: 3.75,
    height: 3.75
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9677",
    "data-name": "Group 9677",
    transform: "translate(166.125 22.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2743",
    "data-name": "Rectangle 2743",
    className: "cls-2",
    width: 3.75,
    height: 3.75
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9678",
    "data-name": "Group 9678",
    transform: "translate(166.125 30)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2744",
    "data-name": "Rectangle 2744",
    className: "cls-2",
    width: 3.75,
    height: 3.75
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9679",
    "data-name": "Group 9679",
    transform: "translate(194.25 86.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2745",
    "data-name": "Rectangle 2745",
    className: "cls-2",
    width: 3.75,
    height: 3.75
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9680",
    "data-name": "Group 9680",
    transform: "translate(138 86.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2746",
    "data-name": "Rectangle 2746",
    className: "cls-2",
    width: 3.75,
    height: 3.75
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9681",
    "data-name": "Group 9681",
    transform: "translate(194.25 30)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2747",
    "data-name": "Rectangle 2747",
    className: "cls-2",
    width: 3.75,
    height: 3.75
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9682",
    "data-name": "Group 9682",
    transform: "translate(138 30)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2748",
    "data-name": "Rectangle 2748",
    className: "cls-2",
    width: 3.75,
    height: 3.75
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiWhite);
export default __webpack_public_path__ + "static/media/siWhite.309e35981accd33e1d55155e95c1622f.svg";
export { ForwardRef as ReactComponent };